'use client';

import { use } from 'react';
import Link from 'next/link';
import { Activity, Stethoscope, ArrowRight, ArrowLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';

/**
 * Dual entry: consumer plan vs health professional.
 * Never label the consumer path as "patient" at the door.
 */
export default function AccesoPage({ params: paramsPromise }) {
  const { locale } = use(paramsPromise);
  const t = useTranslations('AccesoDual');

  return (
    <main className="min-h-screen bg-[#020617] text-white px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <Link
          href={`/${locale}`}
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-300 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          {t('backHome')}
        </Link>

        <p className="text-cyan-300/90 text-xs font-semibold tracking-[0.2em] uppercase mb-3">
          {t('eyebrow')}
        </p>
        <h1 className="text-3xl md:text-5xl font-black tracking-tight leading-tight">
          {t('title')}
        </h1>
        <p className="mt-4 text-slate-300 text-lg max-w-2xl leading-relaxed">{t('subtitle')}</p>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          <Link
            href={`/${locale}/register`}
            className="group rounded-3xl border border-cyan-500/30 bg-slate-950/80 p-7 hover:border-cyan-400/60 hover:bg-slate-900 transition"
          >
            <Activity className="w-8 h-8 text-cyan-400 mb-4" />
            <h2 className="text-xl font-bold text-white group-hover:text-cyan-200">
              {t('userTitle')}
            </h2>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{t('userBody')}</p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-cyan-300">
              {t('userCta')} <ArrowRight className="w-4 h-4" />
            </span>
          </Link>

          <Link
            href={`/${locale}/especialistas/acceso`}
            className="group rounded-3xl border border-emerald-500/30 bg-slate-950/80 p-7 hover:border-emerald-400/60 hover:bg-slate-900 transition"
          >
            <Stethoscope className="w-8 h-8 text-emerald-400 mb-4" />
            <h2 className="text-xl font-bold text-white group-hover:text-emerald-200">
              {t('proTitle')}
            </h2>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{t('proBody')}</p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-emerald-300">
              {t('proCta')} <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        </div>

        <p className="mt-8 text-xs text-slate-500 leading-relaxed max-w-2xl">{t('footnote')}</p>
      </div>
    </main>
  );
}
